// 'production' 'test' 'development'
var env_config = process.env.CODE_ENV

var tracking_url;
var proxyTable_config;
var market_marketMid,market_jumpToLogin;
var index_marketMid ;
var index_jumpToLogin ;
var index_jumpToIndex ;
var index_decisionLogin;
var index_decisionLogout;

// 测试环境配置
var loginComponent_url ;
// 验证码图片
var loginComponent_jumpToIndex ;



if('devbuild' == env_config)
{
  tracking_url = "https://testbmtracking.bluemoon.com.cn/bd-api-tracking/api/script?appId=WEB_DOMP";

  proxyTable_config = {
    '/user': 'http://dompapi.bluemoon.com.cn/bd-domp-service/',
  '/membership': 'http://dompapi.bluemoon.com.cn/bd-domp-service/',
  '/domp': 'http://dompapi.bluemoon.com.cn/bd-domp-service/',
  '/sso': 'http://dompapi.bluemoon.com.cn/bd-domp-service/'};

  // 测试环境
  market_marketMid =  929261381; // 测试环境 应用市场mid
  market_jumpToLogin =  'http://dompapi.bluemoon.com.cn/bd-portal-view/index.html#/login';


  index_marketMid =  929261381; // 测试环境 应用市场mid
  index_jumpToLogin = 'http://dompapi.bluemoon.com.cn/bd-portal-view/index.html#/login';
  index_jumpToIndex =   'http://dompapi.bluemoon.com.cn/bd-portal-view/index.html#/index';
  index_decisionLogin =   'https://testbmreport.bluemoon.com.cn/webroot/decision/login/cross/domain';
  index_decisionLogout =   'https://testbmreport.bluemoon.com.cn/webroot/decision/logout/cross/domain';

  // 测试环境配置
  loginComponent_url = 'http://dompapi.bluemoon.com.cn/bd-domp-service/membership/pcrimg_v2?date='; // 验证码图片
    loginComponent_jumpToIndex = 'http://dompapi.bluemoon.com.cn/bd-portal-view/index.html#/index';


}
else if('production' == env_config)
{
  tracking_url = "https://bmtracking.bluemoon.com.cn/bd-api-tracking/api/script?appId=WEB_DOMP";

  proxyTable_config = {
    '/user': 'http://domp.bluemoon.com.cn/bd-domp-service/',
    '/membership': 'http://domp.bluemoon.com.cn/bd-domp-service/',
    '/domp': 'http://domp.bluemoon.com.cn/bd-domp-service/',
    '/sso': 'http://domp.bluemoon.com.cn/bd-domp-service/'
  };

    market_marketMid = 1085634561;
    market_jumpToLogin = 'http://domp.bluemoon.com.cn/bd-portal-view/index.html#/login';

    index_marketMid =  1085634561; // 应用市场mid
    index_jumpToLogin = 'http://domp.bluemoon.com.cn/bd-portal-view/index.html#/login';
    index_jumpToIndex =  'http://domp.bluemoon.com.cn/bd-portal-view/index.html#/index';
    index_decisionLogin = 'https://bmreport.bluemoon.com.cn/webroot/decision/login/cross/domain';
    index_decisionLogout =  'https://bmreport.bluemoon.com.cn/webroot/decision/logout/cross/domain';

  loginComponent_url =  'http://domp.bluemoon.com.cn/bd-domp-service/membership/pcrimg_v2?date='; // 验证码图片
    loginComponent_jumpToIndex = 'http://domp.bluemoon.com.cn/bd-portal-view/index.html#/index';

}
else if('development' == env_config)
{

  // 测试环境
  market_marketMid =  929261381; // 测试环境 应用市场mid
  market_jumpToLogin = 'http://localhost:8080/#/login';


  index_marketMid =  929261381; // 测试环境 应用市场mid
  index_jumpToLogin = 'http://localhost:8080/#/login';
  index_jumpToIndex =   'http://localhost:8080/#/index';

  // 测试环境配置
  loginComponent_url = 'http://dompapi.bluemoon.com.cn/bd-domp-service/membership/pcrimg_v2?date='; // 验证码图片
  loginComponent_jumpToIndex =  'http://localhost:8080/#/index';
}
else;

window.tracking_url = tracking_url;


export {
  env_config,
  tracking_url,
  proxyTable_config,
  market_marketMid,
  market_jumpToLogin,
  index_marketMid ,
  index_jumpToLogin ,
  index_jumpToIndex,
  index_decisionLogin,
  index_decisionLogout,
  // 测试环境配置
  loginComponent_url,
  // 验证码图片
  loginComponent_jumpToIndex,
} ;



// WEBPACK FOOTER //
// ./src/env_config.js